// Dedicated URL helper for Set-Cookie Lambda
// Each environment (dev, st, prd) can point to a DIFFERENT API Gateway stage
// without touching the existing opt-in helpers.

const DEV_URL = 'https://cross-login-api.alc.co.jp/dev/'
const ST_URL = 'https://cross-login-api.alc.co.jp/stg/'
const PRD_URL = 'https://cross-login-api.alc.co.jp/prod/'

const DEV_AWS_USER_POOLS_ID = 'ap-northeast-1_AgekSaVWt'
const ST_AWS_USER_POOLS_ID = 'ap-northeast-1_dGRckDhQ3'
const PRD_AWS_USER_POOLS_ID = 'ap-northeast-1_bwFvWPddH'

const URI_SET_COOKIE = 'SetCognitoCookie'
const URI_CLEAR_COOKIE = 'ClearCognitoCookie'

function base_url(aws_user_pools_id) {
    if (aws_user_pools_id === PRD_AWS_USER_POOLS_ID) return PRD_URL
    if (aws_user_pools_id === ST_AWS_USER_POOLS_ID) return ST_URL
    return DEV_URL
}

export function set_cookie_url(aws_user_pools_id) {
    return base_url(aws_user_pools_id) + URI_SET_COOKIE
}

export function clear_cookie_url(aws_user_pools_id) {
    return base_url(aws_user_pools_id) + URI_CLEAR_COOKIE
}

export default {
    set_cookie_url,
    clear_cookie_url,
} 